module.exports = __webpack_public_path__ + "img/car1.3a08e193.png";